class ThemeComposite {
  constructor() {
    this.themeItem = new Map();
  }

  Register(name, component) {
    if (!this.themeItem.get(name)) this.themeItem.set(name, component);
  }

  Unregister(name) {
    if (!!this.themeItem.get(name)) this.themeItem.delete(name);
  }

  SetTheme(theme) {
    this.themeItem.forEach((item) => {
      item.SetTheme(theme);
    });
  }
}

export default ThemeComposite;
